module.exports = __webpack_public_path__ + "static/img/33.fdd9a685.svg";